// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"81b92890","453":"2ba006bb"}[chunkId] + ".chunk.js";
};